import { useState, useEffect } from "react";
import { FaUniversity } from "react-icons/fa";
import "./profile.css";

export default function BankAccount({ personal, onSave, saving }) {
  const [form, setForm] = useState({
    bank_account_number: personal.bank_account_number || "",
    ifsc_code: personal.ifsc_code || "",
    bank_name: personal.bank_name || "",
  });

  // Keep the form in sync whenever the parent re-fetches the profile
  useEffect(() => {
    setForm({
      bank_account_number: personal.bank_account_number || "",
      ifsc_code: personal.ifsc_code || "",
      bank_name: personal.bank_name || "",
    });
  }, [
    personal.bank_account_number,
    personal.ifsc_code,
    personal.bank_name,
  ]);

  const handleSave = async () => {
    await onSave(form);
  };

  const hasExisting =
    personal.bank_account_number || personal.ifsc_code || personal.bank_name;

  return (
    <div className="account-card">
      <h2>Bank Account Details</h2>

      <div className="form-section-card security-section">
        <div className="section-title-premium">
          <FaUniversity /> {hasExisting ? "Update Bank Details" : "Add Bank Details"}
        </div>

        <div className="grid-2">
          <div className="account-field">
            <label>Bank Account Number</label>
            <input
              type="text"
              value={form.bank_account_number}
              placeholder="Enter account number"
              onChange={(e) =>
                setForm({ ...form, bank_account_number: e.target.value })
              }
            />
          </div>

          <div className="account-field">
            <label>IFSC Code</label>
            <input
              type="text"
              value={form.ifsc_code}
              placeholder="e.g. HDFC0001234"
              onChange={(e) =>
                setForm({ ...form, ifsc_code: e.target.value.toUpperCase() })
              }
            />
          </div>
        </div>

        <div className="grid-2">
          <div className="account-field field-span-2">
            <label className="confirm">Bank Name</label>
            <input
              type="text"
              value={form.bank_name}
              placeholder="Enter bank name"
              onChange={(e) => setForm({ ...form, bank_name: e.target.value })}
            />
          </div>
        </div>

        <button
          className="account-save-btn security-save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="btn-spinner" />
              Saving…
            </>
          ) : hasExisting ? (
            "Update Bank Details"
          ) : (
            "Save Bank Details"
          )}
        </button>
      </div>
    </div>
  );
}